export class Rights {
    canViewBudget:number = 0;       // whether or not user has access to view Planner`s services
    canManageAllBudgets:number = 0; // whether or not user can add,edit,upload,delete any data in Planner
    canManageOwnBudgets: number = 0; // whether or not user can add,edit,upload,delete only own data in Planner,
    canViewScraper:number = 0;      // whether or not user has access to Inventory Scraper
    canViewAdmin:number = 0;         // whether or not user has access to Admin panel
    budgetDealerGroups: [
      {
        dealerGroupId: number,
        canManageMediaCategories: number
      }
    ];
    constructor (data) {
      this.canViewBudget = data.canViewBudget;
      this.canManageAllBudgets = data.canManageAllBudgets;
      this.canManageOwnBudgets = data.canManageOwnBudgets;
      this.canViewScraper = data.canViewScraper;
      this.canViewAdmin = data.canViewAdmin;
      this.budgetDealerGroups = data.budgetDealerGroups;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/rights.ts